// file: resources/js/store/settings.ts
import { defineStore } from 'pinia'
import API from '../services/api' // Sesuaikan path ke file API Anda

// Tipe data untuk settings yang diambil
interface PublicSettings {
  company_brand_name?: string
  company_logo?: string
  company_logo_1?: string
  company_logo_2?: string
  company_web_favicon?: string
  primary_color?: string
  secondary_color?: string
  background_color?: string
}

export const useSettingsStore = defineStore('settings', {
  // 1. STATE: Tempat menyimpan data
  state: () => ({
    settings: {} as PublicSettings,
    isLoading: true, // Mulai dengan loading
  }),

  // 2. GETTERS: Cara mudah mengakses data yang sudah diolah
  getters: {
    /**
     * Mengembalikan URL lengkap ke logo perusahaan, atau null jika tidak ada.
     */
    logoUrl(state): string | null {
      if (state.settings.company_logo) {
        // Ambil VITE_API_STORAGE_URL dari file .env Anda
        const storageBaseUrl = import.meta.env.VITE_API_STORAGE_URL || 'http://localhost:8000/storage'
        return `${storageBaseUrl}/${state.settings.company_logo}`
      }
      return null
    },

    /**
     * Mengembalikan URL lengkap ke logo perusahaan versi 1, atau null jika tidak ada.
     */
    logoUrl1(state): string | null {
      if (state.settings.company_logo_1) {
        const storageBaseUrl = import.meta.env.VITE_API_STORAGE_URL || 'http://localhost:8000/storage'
        return `${storageBaseUrl}/${state.settings.company_logo_1}`
      }
      return null
    },

    /**
     * Mengembalikan URL lengkap ke logo perusahaan versi 2, atau null jika tidak ada.
     */
    logoUrl2(state): string | null {
      if (state.settings.company_logo_2) {
        const storageBaseUrl = import.meta.env.VITE_API_STORAGE_URL || 'http://localhost:8000/storage'
        return `${storageBaseUrl}/${state.settings.company_logo_2}`
      }
      return null
    },

    primaryColor(state): string | null {
      return state.settings.primary_color || null
    },
    secondaryColor(state): string | null {
      return state.settings.secondary_color || null
    },
    backgroundColor(state): string | null {
      // Vuestic menggunakan 'background' (bukan 'background_color')
      // jadi kita bisa beri nama 'backgroundColor' agar jelas
      return state.settings.background_color || null
    },

    /**
     * Mengembalikan nama perusahaan, atau string kosong.
     */
    companybrandName(state): string {
      return state.settings.company_brand_name || ''
    },

    faviconUrl(state): string | null {
      if (state.settings.company_web_favicon) {
        const storageBaseUrl = import.meta.env.VITE_API_STORAGE_URL || 'http://localhost:8000/storage'
        return `${storageBaseUrl}/${state.settings.company_web_favicon}`
      }
      return null
    },
  },

  // 3. ACTIONS: Fungsi untuk mengambil data dari API
  actions: {
    /**
     * Mengambil data public settings dari API.
     * Hanya akan berjalan satu kali.
     */
    async fetchPublicSettings() {
      // Hentikan jika data sudah diisi (mencegah fetch berulang)
      if (Object.keys(this.settings).length > 0) {
        return
      }

      this.isLoading = true
      try {
        // Panggil endpoint publik baru yang kita buat di Bagian 1
        const response = await API.get('public-settings')
        this.settings = response.data.data
      } catch (error) {
        console.error('Failed to fetch public settings:', error)
      } finally {
        this.isLoading = false
      }
    },
  },
})
